{
  "Login": {
    "Title": "Masuk untuk menyimpan tanda terima Anda",
    "WaitingScreenLoginTitle": "Login untuk notifikasi tanda terima Anda",
    "GoogleButton": "Lanjutkan dengan Google",
    "FacebookButton": "Lanjutkan dengan Facebook",
    "KakaoButton": "Continue with Kakao",
    "NaverButton": "Continue with Naver",
    "LineButton": "Masuk dengan LINE",
    "OR": "ATAU",
    "MobileNumber": "Nomor HP",
    "Continue": "Daftar dengan nomor HP",
    "EndUserLicenseAgreement": "Syarat dan Ketentuan",
    "PrivacyPolicy": "Kebijakan Privasi.",
    "EulaAndPrivacyPolicyTerm": "Dengan mendaftar, saya menyetujui \n{eula} serta {privacyPolicy}",
    "OtherLoginMethods": "Metode Login Lainnya",
    "SelectCountry": "Silakan pilih negara atau lokasi Anda",
    "EncourageSocialLogin": "For a faster and more secure experience, \n{signInText}",
    "EncourageSocialLogin2": "sign in via Social Login"
  },
  "BottomNavbar": {
    "Receipts": "Tanda terima",
    "Account": "Akun"
  },
  "PhoneVerification": {
    "Title": "Verifikasi Nomor HP",
    "EnterCode": "Masukan Kode",
    "SMSDiscription": "Kode Verifikasi telah dikirim melalui SMS ke Nomor",
    "EnterOTP": "Masukan 6-digit kode",
    "InvalidOtp": "Kode tidak valid",
    "TryAgainInfo": "Mohon mencoba kembali.",
    "OTPExpireTime": "The OTP code will expire in ",
    "OTPNotArrive": "Haven't receive the code?",
    "Resend": "Resend OTP",
    "ChangePhone": "Change Phone Number",
    "ResendToast": "We've sent a new 6-digit OTP code to your phone."
  },
  "ReceiptLoader": {
    "PreparingText": "Sedang mempersiapkan\ntanda terima anda...",
    "TakingLongerText": "Tanda terima anda sedang diproses sedikit lebih lama dari biasanya...",
    "NotifyText1": "Dapatkan notifikasi ketika tanda terima anda tersedia",
    "NotifyText2": "Akan kami notifikasi anda jika tanda terima sudah tersedia",
    "OKButton": "OK",
    "LoginButton": "LOGIN",
    "NotifyMeButton": "Notifikasi saya",
    "ReceiptWait": "Harap menunggu, tanda terima anda akan tampil disini setelah transaksi selesai.",
    "UtilisedReceiptText": "Tanda terima ini telah terhubung dengan akun yang lain",
    "ReceiptExpiredText": "Tanda terima yang belum tersimpan sudah kadaluarsa. Silahkan menyimpan tanda terima lain kali.",
    "ReceiptLinkExpired": "Link tanda terima sudah kadaluarsa. Silahkan menyimpan tanda terima lain kali.",
    "VoidReceiptTitle": "This Receipt is voided",
    "VoidReceiptSubtitle": "Please contact the merchant for more information.",
    "SharedReceiptText": "Silahkan Login untuk melihat tanda terima yang dikirimkan kepada anda.",
    "InvalidHashText": "Tidak dapat memuat tanda terima sekarang. URL tanda terima salah."
  },
  "SaveReceipt": {
    "Description": "Tanda terima Anda belum tersimpan!\nTekan tombol untuk menyimpannya.",
    "SaveReceipt": "Menyimpan tanda terima",
    "SaveInfo": "Tanda terima telah tersimpan di Piperks.",
    "UpdatedGoogleWallet": "Saved to Google Wallet"
  },
  "PushNotification": {
    "NewReceipt": "Akses tanda terima baru\ndengan push notifikasi.",
    "Notification": "Notifikasi",
    "AllowNotification": "Ijinkan notifikasi dari Piperks?",
    "Deny": "Tidak",
    "Allow": "Setuju",
    "NotificationInfo": "Akan kami kabari ketika tanda terima sudah tiba"
  },
  "WhatsAppPrompt": {
    "Title": "Kami di sini untuk membantu",
    "SubTitle": "Pilih yang mau anda sampaikan:",
    "IssueWithPurchase": "Masalah dalam transaksi",
    "Feedback": "Kritik dan Saran",
    "ReceiptError": "Masalah pada tanda terima",
    "AccountIssue": "Masalah Akun",
    "ReceiptNumber": "Nomor tanda terima saya adalah {receiptNo}",
    "IssuePurchaseText": "Saya memiliki masalah dengan transaksi saya. ",
    "FeedbackText": "Saya memiliki kritik dan saran kepada anda. ",
    "ReceiptErrorText": "Saya memiliki masalah dengan tanda terima saya. ",
    "AccountIssueText": "Saya memiliki masalah pada akun saya. "
  },
  "QRReader": {
    "Title": "Pindai kode QR pada tanda terima Anda",
    "BackButton": "Kembali",
    "InvalidQR": "QR Tidak Valid",
    "InvalidQRInfo": "Tolong scan QR Code yang tercetak pada tanda terima"
  },
  "PWAPrompt": {
    "Description": "Akses penerimaan secara offline dengan\nsatu ketukan install.",
    "Install": "INSTALL"
  },
  "MyReceipts": {
    "Title": "Tanda Terima Anda",
    "ReceiptLoadingText": "Loading...",
    "EmptyInfo": "Akan lebih ramai ketika tanda terima Anda\nmulai tersimpan di sini!",
    "NotifyInfo": "Akan kami kabari ketika tanda terima telah disimpan",
    "EmptyFilter": "Ubah pengaturan filter untuk menampilkan lebih banyak tanda terima",
    "EndOfReceipts": "Semua tanda terima telah ditampilkan"
  },
  "SalesReceipt": {
    "HelpText": "Perlu Bantuan?",
    "WhatsAppButton": "Kirim pesan melalui WhatsApp",
    "FollowUs": "Follow Us On:"
  },
  "ReceiptExport": {
    "ExportingReceiptText": "Tanda terima sedang diunduh.",
    "ReceiptExportSuccessText": "Tanda terima telah diunduh."
  },
  "Settings": {
    "ProfileCompleteText": "Lengkapi Profil Anda",
    "AccountInformation": "Informasi Akun",
    "EnterDetailsText": "Silahkan melengkapi detail Anda untuk pemulihan akun",
    "Name": "Nama",
    "Edit": "Edit",
    "Male": "Pria",
    "Phone": "Nomor Handphone",
    "Gender": "Jenis Kelamin",
    "Dob": "Tanggal Lahir",
    "Email": "Email",
    "Female": "Wanita",
    "Other": "Lainnya",
    "Indonesia": "Indonesia",
    "Malaysia": "Malaysia",
    "Singapore": "Singapura",
    "SouthKorea": "Korea Selatan",
    "Japan": "Jepang",
    "SetNow": "Atur Sekarang",
    "HomeAddress": "Alamat",
    "LocationAndLanguage": "Lokasi & Bahasa",
    "DisplayLanguage": "Silahkan pilih Bahasa yang Anda inginkan",
    "Country": "Negara",
    "Language": "Bahasa",
    "LocationAccessTitle": "Akses Lokasi",
    "LocationAccessDescription": "Mengizinkan untuk mengatur Bahasa secara otomatis.",
    "Notification": "Pemberitahuan",
    "PushNotification": "Push Notification",
    "GetUpdates": "Dapatkan update penting untuk Anda",
    "ReceiptAlerts": "Notifikasi Untuk Tanda Terima",
    "NotifiedLatestReceiptsAndUpdates": "Terima pemberitahuan untuk tanda terima terbaru dan update.",
    "LinkedAccounts": "Link Akun",
    "EnableLogins": "Aktifkan untuk login lebih cepat",
    "PwaInstallButton": "Install Piperks App",
    "ContactSupportButton": "Hubungi Bantuan",
    "LogoutButton": "Logout",
    "Version": "Versi",
    "SupportViaWhatsApp": "Bantuan melalui WhatsApp",
    "SupportViaEmail": "Bantuan melalui Email"
  },
  "Modal": {
    "PushNotif": {
      "Title": "Push notification terblokir ?",
      "Message1": "Silahkan ikuti langkah dibawah untuk mengijinkan Push Notification secara manual.",
      "Message2": "1. Klik pada ikon informasi yang berada di sebelah kiri dari URL tab.",
      "Message3": "2. Pada bagian “Notifikasi”, pilih antara “Tanya” atau “Ijinkan”. ",
      "Message4": "3. Muat ulang halaman untuk menjalankan pengaturan yang diperbaharui."
    },
    "Location": {
      "Title": "Lokasi terblokir ?",
      "Message1": "Silahkan ikuti langkah dibawah untuk mengijinkan Lokasi secara manual",
      "Message2": "1. Klik pada ikon informasi yang berada di sebelah kiri dari URL tab.",
      "Message3": "2. Pada bagian “Lokasi”, pilih antara “Tanya” atau “Ijinkan”.",
      "Message4": "3. Muat ulang halaman untuk menjalankan pengaturan yang diperbaharui"
    },
    "BaseCountry": {
      "Title": "Negara",
      "Message1": "Negara yang tertera pada halaman akun anda adalah dimana data anda disimpan.",
      "Message2": "Saat ini data anda disimpan di '{0}'",
      "Message3": "Jika anda ingin mengubah lokasi dimana data anda disimpan, ",
      "Action1": "klik disini"
    }
  },
  "Message": {
    "Subject": "Dibutuhkan bantuan untuk Piperks App",
    "TypeMessage": "Silahkan ketik pesan anda disini:",
    "HelpTroubleshoot": "[JANGAN HAPUS BAGIAN INI UNTUK MEMBANTU PEMECAHAN MASALAH]",
    "PhoneModel": "Model Handphone: ",
    "PhoneOS": "Versi OS Handphone: ",
    "BrowserVersion": "Versi Browser: ",
    "RegisteredID": "ID Registrasi: ",
    "LatestReceipt": "Tanda Terima Terakhir: "
  },
  "ReceiptDetail": {
    "Store": "Toko: ",
    "POS": "POS: ",
    "Cashier": "Kasir: ",
    "TotalSpend": "TOTAL PEMBELANJAAN",
    "PreSettlementTotalSpend": "PROCESSING PAYMENT",
    "YouSave": "ANDA MENGHEMAT",
    "TotalPaid": "TOTAL PEMBAYARAN",
    "Change": "KEMBALIAN",
    "Tax": "PAJAK: ",
    "Items": "BARANG",
    "ItemReturned": "# BARANG KEMBALI ",
    "ItemSold": "# BARANG TERJUAL",
    "WifiPassword": "Salin Password Wifi",
    "FreeWifi": "WIFI GRATIS",
    "PreSettlementTotal": "NOT YOUR FINAL RECEIPT.\n\nFINAL RECEIPT WILL APPEAR ONCE PAYMENT IS\nSUCCESSFUL\n\n"
  },
  "Receipt": {
    "Today": "Hari Ini",
    "Yesterday": "Kemarin"
  },
  "DemoError": {
    "title": "Aplikasi ini adalah Versi Demo",
    "message": "Mohon gunakan URL Demo yang telah diberikan atau meminta URL Demo dengan menghubungi"
  },
  "DataPrompt": {
    "Title": "Verifikasi Akun",
    "Body": "Amankan tanda terima anda dengan memverifikasi informasi anda untuk validasi akun atau pemulihan data di masa mendatang",
    "Gender": "Jenis Kelamin",
    "YOB": "Tahun Kelahiran",
    "Submit": "Simpan",
    "Later": "Nanti",
    "Select": "Pilih",
    "DrawerTitle": "Amankan tanda terima anda dengan memverifikasi detail akun anda",
    "DrawerBody": "Verifikasi Akun"
  },
  "Eula": {
    "Title": "Perjanjian Pengguna"
  },
  "SortFilter": {
    "Title": "Sortir dan Filter",
    "SortBy": "Urutkan berdasarkan",
    "DateAsc": "Tanggal (Lama - Baru)",
    "DateDesc": "Tanggal (Baru - Lama)",
    "TransactionAsc": "Harga (Rendah - Tinggi)",
    "TransactionDesc": "Harga (Tinggi - Rendah)",
    "DateRange": "Rentang Waktu",
    "Store": "Toko",
    "SeeMore": "Lihat Lainnya",
    "ShowLess": "Sembunyikan",
    "Apply": "Pakai",
    "Reset": "Reset",
    "LastWeek": "Seminggu Lalu",
    "LastMonth": "Sebulan Lalu"
  },
  "KoreanExplicit": {
    "Title": "Please agree to use Piperks service",
    "AcceptAll": "Accept All",
    "Required": "Required",
    "TermOfUse": "Terms of Use ",
    "PrivacyPolicy": "Privacy Policy",
    "AgeConsent": "I am 14 years old or older",
    "Continue": "Continue",
    "ViewMore": "view more"
  },
  "Error": {
    "UnexpectedError": "Kesalahan tak terduga!",
    "TryAgain": "Harap mencoba sebentar lagi",
    "BtnTextOK": "OK",
    "BtnTextRetry": "Retry",
    "OtpSendingFailed": {
      "Title": "Failed to send OTP",
      "Body": "Please try again after a few minutes"
    },
    "InvalidPhoneNumber": {
      "Title": "Failed to send OTP",
      "Body": "The phone number you provided is not in the correct format. Please enter your phone number without a country code."
    },
    "IncorrectOtp": {
      "Title": "Incorrect OTP",
      "Body": "Please verify the OTP sent to your registered phone number"
    },
    "SocialLoginFailed": {
      "Title": "{ provider } Login Failed",
      "Body": "Kindly wait a few minutes before retrying"
    },
    "LoginUnsuccessful": {
      "Title": "Login Unsuccessful",
      "Body": "Apologies, an error occurred during your login. Please try again later"
    },
    "UserReceiptsQueryFails": {
      "Title": "Receipt Loading Error",
      "Body": "We're sorry, there was an issue retrieving your receipt. Please try again shortly"
    },
    "CreateTransactionError": {
      "Title": "Transaction Creation Error",
      "Body": "Apologies, we were unable to create a transaction for your receipt. Please try again soon"
    },
    "GetReceiptError": {
      "Title": "Receipt Retrieval Error",
      "Body": "We're sorry, an unexpected error occurred while fetching your receipt. Please try again shortly"
    },
    "GetReceiptTemplateError": {
      "Title": "Template Retrieval Failed",
      "Body": "We're sorry, an error occurred while fetching the receipt template. Please try again shortly"
    },
    "LinkReceiptError": {
      "Title": "Receipt Linking Error",
      "Body": "Apologies, we were unable to link the receipt to your account. Please try again soon"
    },
    "ReceiptSubscriptionError": {
      "Title": "Failed to retrieve real-time receipts"
    },
    "AccountUpdateFailed": {
      "Title": "Account Update Failed",
      "Body": "We're sorry, an error occurred while updating your account. Please try again shortly"
    },
    "AccountRetrievalFailed": {
      "Title": "Account Retrieval Failed",
      "Body": "We're sorry, an error occurred while fetching your account data"
    },
    "ServerUnavailable": {
      "Title": "Server Unavailable",
      "Body": "We're currently fixing the issue. Please try again in a few minutes"
    },
    "MissingQueryParam": {
      "Title": "Receipt Not Found",
      "Body": "Looks like something is missing on your receipt link. Please double-check and try again"
    },
    "InvalidReceiptToken": {
      "Title": "Receipt Link Not Found",
      "Body": "We couldn't find the receipt link in our system. Reach out to the cashier for more information."
    },
    "ExpiredReceiptLink": {
      "Title": "Receipt Link Expired",
      "Body": "Looks like the receipt link has expired. Reach out to the cashier for a new receipt link."
    },
    "ExpiredShareReceipt": {
      "Title": "Share Link Has Expired",
      "Body": "The shared receipt link has expired. Please ask the sender for a new link or check the shared receipt’s link."
    },
    "InvalidShareReceipt": {
      "Title": "Share Link Not Available",
      "Body": "The shared receipt link is not available. Please ask the sender for a new link or check the shared receipt’s link."
    }
  }
}
